import PageHeader from '@components/common/PageHeader';
import styles from './GrowthDashboard.module.css';
import GrowthMap from '@/page/growth/dashboard/GrowthMap';
import Chart1 from '@/page/growth/dashboard/Chart1';
import Chart7 from './Chart7';
import Chart8 from './Chart8';
import Chart9 from '@/page/growth/dashboard/Chart9';
import Chart10 from '@/page/growth/dashboard/Chart10';
import Chart11 from './Chart11';
import Chart12 from './Chart12';
import Chart13 from './Chart13';
import Chart14 from './Chart14';
import Chart15 from './Chart15';
import Chart16 from '@/page/growth/dashboard/Chart16';
import Chart17 from '@/page/growth/dashboard/Chart17';
import Chart18 from '@/page/growth/dashboard/Chart18';
import Chart19 from '@/page/growth/dashboard/Chart19';
import Chart21 from './Chart21';
import Chart20 from './Chart20';
import Chart23 from './Chart23';
import Chart24 from './Chart24';
import Chart25 from '@/page/growth/dashboard/Chart25';
import Chart26 from './Chart26';
import Chart28 from './Chart28';
import Chart29 from './Chart29';

const GrowthDashboard = () => {
    return (
        <>
            <PageHeader
                title="생육대시보드"
                breadcrumbs={[
                    { label: '홈', href: '/' },
                    { label: '생육관리' },
                    { label: '생육대시보드', active: true },
                ]}
            />

            <div className="row mt-4">
                <div className="col-12 col-md-6">
                    <div className="card custom-card profile-card overflow-hidden">
                        <div
                            className={`${styles['candidate-bg-shape']} primary`}
                            style={{
                                background:
                                    'url(https://i.pinimg.com/1200x/ff/a6/00/ffa600dc0597481a91dd640710ec9ed3.jpg)',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                            }}
                        ></div>
                        <div className="card-body pt-5">
                            <div className="d-flex gap-2 flex-wrap mb-1 mt-5">
                                <div className="flex-fill mt-5">
                                    <h6 className="mb-1 fw-semibold">
                                        <a href="javascript:void(0);">
                                            감곡농장
                                            <i
                                                className="ri-check-line text-success fs-16"
                                                data-bs-toggle="tooltip"
                                                aria-label="Verified candidate"
                                                data-bs-original-title="Verified candidate"
                                            ></i>
                                        </a>
                                    </h6>
                                    <p className="mb-0 text-muted"></p>
                                    <div className="d-flex flex-wrap gap-2 align-items-center fs-12 text-muted">
                                        <p className="mb-0">
                                            <i className="ri-map-line me-1 text-muted"></i>{' '}
                                            <span className="fw-medium">
                                                면적 : 7,116 m²
                                            </span>
                                        </p>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 align-items-center fs-12 text-muted">
                                        <p className="mb-0">
                                            <i className="ri-map-pin-line me-1 text-muted"></i>{' '}
                                            <span className="fw-medium">
                                                충청남도 천안시 동남구 북면
                                                은지리 309-8, 충청남도 천안시
                                                동남구 북면
                                            </span>
                                        </p>
                                    </div>

                                    <div className="d-flex fs-14 mt-3 gap-2 flex-wrap">
                                        <div className="me-3">
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-leaf-fill align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    상태 :{' '}
                                                    <span className="text-muted fw-normal">
                                                        <div className="badge bg-success">
                                                            진행중
                                                        </div>
                                                    </span>
                                                </span>
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-calendar-line align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    작기 :{' '}
                                                    <span className=" fw-normal">
                                                        2025-01-01~2025-12-31
                                                    </span>
                                                </span>
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-scales-2-line align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    현재예상수확량 :{' '}
                                                    <span className=" fw-normal">
                                                        924 kg/ha
                                                    </span>
                                                </span>
                                            </p>
                                        </div>
                                        <div className="me-3">
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-shining-2-line align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    작물 :{' '}
                                                    <span className=" fw-normal">
                                                        <img
                                                            className={
                                                                styles[
                                                                    'crop-icon'
                                                                ]
                                                            }
                                                            src="/images/crop/potato.png"
                                                            alt="감자"
                                                        />
                                                    </span>{' '}
                                                    감자 / 수미
                                                </span>
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-refresh-line align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    업데이트 :{' '}
                                                    <span className=" fw-normal">
                                                        2022-01-01 21:32:11
                                                    </span>
                                                </span>
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-scales-2-fill align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    최대예상수확량 :{' '}
                                                    <span className=" fw-normal">
                                                        2,324 kg/ha
                                                    </span>
                                                </span>
                                            </p>
                                        </div>
                                        <div className="me-3">
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-seedling-line align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    생육단계 : 발아기
                                                </span>
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                                    <i className="ri-calendar-schedule-line align-middle fs-15"></i>
                                                </span>
                                                <span className="">
                                                    예상수확일 : 2022-10-23
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="fs-11 text-muted">
                                        * 입력된 작물, 농작업, 토양데이터
                                        기반으로 예측정보는 실제 수확정보와
                                        다를수있음을 알립니다.
                                    </div>
                                    {/*<div className="">
                                                <div className="d-flex align-items-center my-2">
                                                    <div className="flex-fill">
                                                        <div className="d-flex align-items-top justify-content-between">
                                                            <span className="fw-semibold mb-0 lh-1">
                                                                생육진행도 - 58%
                                                                / 남은일수 72일
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    role="progressbar"
                                                    aria-valuenow={72}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                    className="progress progress-lg p-1 progress-animate progress"
                                                >
                                                    <div
                                                        role="progressbar"
                                                        className="progress-bar progress-bar-striped bg-success progress-bar"
                                                        aria-valuenow={72}
                                                        aria-valuemin={0}
                                                        aria-valuemax={100}
                                                        style={{ width: '58%' }}
                                                    ></div>
                                                </div>
                                            </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="card custom-card">
                        <div className="card-body">
                            <GrowthMap />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-2">
                    <div className="custom-card card project-cards success">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                                <div>
                                    <div className="fs-13 align-middle text-muted mb-1">
                                        파종일자
                                    </div>
                                    <div className="text-muted fs-12 mb-1">
                                        <span className="text-success fw-semibold fs-18">
                                            2025.04.11
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 justify-content-between flex-wrap align-items-center">
                                        <div className="fs-12 mb-0">
                                            평균보다
                                        </div>
                                        <div className="badge bg-danger-transparent rounded-pill">
                                            + 3일
                                        </div>
                                    </div>
                                </div>
                                <div className="text-success p-1 rounded-circle border border-success border-opacity-25 shadow-sm ms-auto">
                                    <div className="p-2 bg-success bg-opacity-25 rounded-circle">
                                        <i className="ri-seedling-fill fs-18 xy20"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-2">
                    <div className="custom-card undefined card project-cards primary">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                                <div>
                                    <div className="fs-13 align-middle text-muted mb-1">
                                        파종방법
                                    </div>
                                    <div className="text-muted fs-12 mb-1">
                                        <span className="text-primary fw-semibold fs-18">
                                            종자흩뿌리기
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 justify-content-between flex-wrap align-items-center">
                                        <div className="fs-12 mb-0">
                                            인기방법
                                        </div>
                                        <div className="badge bg-danger-transparent rounded-pill">
                                            고랑파종
                                        </div>
                                    </div>
                                </div>
                                <div className="text-primary p-1 rounded-circle border border-primary border-opacity-25 shadow-sm ms-auto">
                                    <div className="p-2 bg-primary bg-opacity-25 rounded-circle">
                                        <i className="ri-flower-line fs-18 xy20"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-2">
                    <div className="custom-card card project-cards secondary">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                                <div>
                                    <div className="fs-13 align-middle text-muted mb-1">
                                        파종간격/깊이
                                    </div>
                                    <div className="text-muted fs-12 mb-1">
                                        <span className="text-secondary fw-semibold fs-18">
                                            3cm/3cm
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 justify-content-between flex-wrap align-items-center">
                                        <div className="fs-12 mb-0">
                                            제일많은방법
                                        </div>
                                        <div className="badge bg-danger-transparent rounded-pill">
                                            4cm/5cm
                                        </div>
                                    </div>
                                </div>
                                <div className="text-secondary p-1 rounded-circle border border-secondary border-opacity-25 shadow-sm ms-auto">
                                    <div className="p-2 bg-secondary bg-opacity-25 rounded-circle">
                                        <i className="ri-ruler-line fs-18 xy20"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-2">
                    <div className="custom-card card project-cards pink">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                                <div>
                                    <div className="fs-13 align-middle text-muted mb-1">
                                        파종량
                                    </div>
                                    <div className="text-muted fs-12 mb-1">
                                        <span className="text-pink fw-semibold fs-18">
                                            2,400kg
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 justify-content-between flex-wrap align-items-center">
                                        <div className="fs-12 mb-0">
                                            평균보다
                                        </div>
                                        <div className="badge bg-danger-transparent rounded-pill">
                                            +300kg
                                        </div>
                                    </div>
                                </div>
                                <div className="text-pink p-1 rounded-circle border border-pink border-opacity-25 shadow-sm ms-auto">
                                    <div className="p-2 bg-pink bg-opacity-25 rounded-circle">
                                        <i className="ri-scales-fill fs-18 xy20"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-2">
                    <div className="custom-card card project-cards info">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                                <div>
                                    <div className="fs-13 align-middle text-muted mb-1">
                                        수분흡수량
                                    </div>
                                    <div className="text-muted fs-12 mb-1">
                                        <span className="text-info fw-semibold fs-18">
                                            0.3mm
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 justify-content-between flex-wrap align-items-center">
                                        <div className="fs-12 mb-0">
                                            수분사용량
                                        </div>
                                        <div className="badge bg-danger-transparent rounded-pill">
                                            1.2mm
                                        </div>
                                    </div>
                                </div>
                                <div className="text-info p-1 rounded-circle border border-info border-opacity-25 shadow-sm ms-auto">
                                    <div className="p-2 bg-info bg-opacity-25 rounded-circle">
                                        <i className="ri-contrast-drop-2-line fs-18 xy20"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-2">
                    <div className="custom-card card project-cards danger">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                                <div>
                                    <div className="fs-13 align-middle text-muted mb-1">
                                        수확까지 남은일수
                                    </div>
                                    <div className="text-muted fs-12 mb-1">
                                        <span className="text-danger fw-semibold fs-18">
                                            72일
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 justify-content-between flex-wrap align-items-center">
                                        <div className="fs-12 mb-0">
                                            생육진행일수
                                        </div>
                                        <div className="badge bg-danger-transparent rounded-pill">
                                            33일
                                        </div>
                                    </div>
                                </div>
                                <div className="text-danger p-1 rounded-circle border border-danger border-opacity-25 shadow-sm ms-auto">
                                    <div className="p-2 bg-danger bg-opacity-25 rounded-circle">
                                        <i className="ri-calendar-schedule-line fs-18 xy20"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-2">
                    <Chart14 />
                </div>
                <div className="col-12 col-md-2">
                    <Chart15 />
                </div>
                <div className="col-12 col-md-2">
                    <Chart16 />
                </div>
                <div className="col-12 col-md-2">
                    <Chart17 />
                </div>
                <div className="col-12 col-md-2">
                    <Chart18 />
                </div>
                <div className="col-12 col-md-2">
                    <Chart19 />
                </div>

                {/*<div className="col-12 col-md-2">
                            <Chart5 />
                        </div>
                        <div className="col-12 col-md-2">
                            <Chart6 />
                        </div>*/}
                <div className="col-12 col-md-2">
                    <Chart20 />
                </div>

                <div className="col-12 col-md-2">
                    <Chart12 />
                </div>
                <div className="col-12 col-md-2">
                    <Chart21 />
                </div>
                <div className="col-12 col-md-3">
                    <Chart1 />
                </div>
                <div className="col-12 col-md-3">
                    <Chart11 />
                </div>

                <div className="col-12 col-md-9">
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <Chart7 />
                        </div>
                        <div className="col-12 col-md-6">
                            <Chart8 />
                        </div>
                        <div className="col-12 col-md-3">
                            <Chart9 />
                        </div>
                        <div className="col-12 col-md-3">
                            <Chart10 />
                        </div>
                        <div className="col-12 col-md-6">
                            <Chart13 />
                        </div>
                        <div className="col-12 col-md-6">
                            <Chart23 />
                        </div>
                        <div className="col-12 col-md-6">
                            <Chart24 />
                        </div>
                        <div className="col-12">
                            <Chart26 />
                        </div>

                        {/*<div className="col-12 col-md-2">
                            <Chart2 />
                        </div>
                        <div className="col-12 col-md-2">
                            <Chart3 />
                        </div>*/}
                        {/*<div className="col-12 col-md-3">
                            <Chart4 />
                        </div>*/}

                        <div className="col-12 col-md-6">
                            <Chart28 />
                        </div>
                        <div className="col-12 col-md-6">
                            <Chart29 />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-3">
                    <div className="row">
                        <div className="col-12">
                            <Chart25 />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GrowthDashboard;
